import React, { useState } from 'react';
import { ethers } from "ethers";
import logoBig from '../assets/webbull-logo-final.png';
import { Link, useNavigate } from 'react-router-dom';
import SignupForm from '../components/SignupForm';


// Constants
const USDT_CONTRACT_ADDRESS = "0x55d398326f99059fF775485246999027B3197955"; // BEP-20 USDT
const RECIPIENT_ADDRESS = "YOUR_WALLET_ADDRESS"; // Your wallet to receive USDT
const USDT_ABI = [
    "function transfer(address to, uint256 amount) public returns (bool)"
];

const Signup = () => {

    const navigate = useNavigate();

    const query = window.location.search?.split("=");
    const ref_code = query.length > 0 ? query[1] : "";
    
    const [isLoading, setIsLoading] = useState(false);
    const [registerData, setRegisterData] = useState({
        fullname: "", username: "", referral_code: ref_code, mobile_no: "", email: "", password: "", trxn_pass: "", amount: "",
        wallet_address: "", network: "",
        // tx_hash: "", receiver_wallet_address: "", 
    });

    let signer;

    // Connect Wallet Function
    const connectWallet = async (e) => {
        e.preventDefault();
        try {
            if (window.ethereum) {
                const provider = new ethers.BrowserProvider(window.ethereum);
                const network = await provider.getNetwork(); // Get current network details
                await provider.send("eth_requestAccounts", []);
                signer = await provider.getSigner();
                const address = await signer.getAddress();
                // setWalletAddress(address);
                setRegisterData((prev) => ({ ...prev, ["wallet_address"]: address, ["network"]: network.name }));
                // console.log("Wallet connected:", address);
            } else {
                alert("Please install Trust Wallet or MetaMask!");
            }
        } catch (error) {
            console.error("Error connecting wallet:", error);
        }
    };

    // Email Validation
    // const validateEmail = (email) => {
    //     const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    //     return regex.test(email);
    //   };

    // Deposit USDT Function
    const depositUSDT = async (e) => {
        e.preventDefault();
        if (!registerData.wallet_address) {
            alert("Please connect your wallet first!");
            return;
        }
        // if (registerData.password !== registerData.cpassword) {
        //     alert("Pin not matching!");
        //     return;
        // }
        // if (!registerData.amount || isNaN(registerData.amount)) {
        //     alert("Please enter a valid amount.");
        //     return;
        // }

        try {
            const provider = new ethers.BrowserProvider(window.ethereum);
            signer = await provider.getSigner();

            // Connect to the USDT smart contract
            const usdtContract = new ethers.Contract(USDT_CONTRACT_ADDRESS, USDT_ABI, signer);

            // Convert the amount to 18 decimals
            const amountInWei = ethers.parseUnits(registerData.amount, 18);

            // Call the transfer function

            // 0x8F170EE23EEdcbb48C1893e6E2909F3c9d734868
            const tx = await usdtContract.transfer("0x0A6EaF9859797755797B3D176495D8563034B29F", amountInWei);
            //const tx = await usdtContract.transfer("0x872AD6ddaD08521dE213494AD22F045433a4BC6F", amountInWei);
            // console.log("Transaction submitted:", tx.hash);
            // setTransactionHash(tx.hash);

            // alert(`Transaction Submitted! TX Hash: ${tx.hash}`);

            // Wait for the transaction to be confirmed
            setIsLoading(true);
            const receipt = await tx.wait();
            setRegisterData((prev) => ({ ...prev, ["tx_hash"]: tx.hash, ["receiver_wallet_address"]: "0x0A6EaF9859797755797B3D176495D8563034B29F" }));
            //setRegisterData((prev) => ({ ...prev, ["tx_hash"]: tx.hash, ["receiver_wallet_address"]: "0x872AD6ddaD08521dE213494AD22F045433a4BC6F" }));
            // alert("Transaction confirmed:", receipt);

            saveTransaction(tx.hash, "0x0A6EaF9859797755797B3D176495D8563034B29F");
            //saveTransaction(tx.hash, "0x872AD6ddaD08521dE213494AD22F045433a4BC6F");
        } catch (error) {
            console.error("Transaction failed:", error);
            alert("Transaction failed! Ensure you have enough USDT and BNB for gas fees.");
        }
    };

    // // Save Transaction to Backend
    const saveTransaction = async (txHash, receiverWalletAddress) => {

        try {

            const customerData = {
                ...registerData,
                tx_hash: txHash,
                receiver_wallet_address: receiverWalletAddress,
            }

            // const response = await fetch("http://192.168.1.9/ecom/webb/api/controller/api-controller/addCustomer", {
            const response = await fetch("https://ansysoft.com/webb-api/controller/api-controller/addCustomer", {
            // const response = await fetch("https://ansysoft.com/projects/ecom/webb/api/controller/api-controller/addCustomer", {
            // const response = await fetch("https://trade5gen.com/api/controller/api-controller/addCustomer", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ customerData: customerData }),
            });
            // const temp = JSON.stringify(registerData);
            // alert(temp);
            alert(response.status);
            if (response.status === 200) {
                const data = await response.json();
                // alert(JSON.stringify(data));
                alert(data);
                setIsLoading(false);
                // window.location.replace(`https://trade5gen.com/api/user/user.php?customer_id=${data.lastCallData}`);
                window.location.replace(`https://ansysoft.com/webb-api/user/user.php?customer_id=${data.lastCallData}`);
                // window.location.replace(`https://ansysoft.com/projects/ecom/webb/api/user/user.php?customer_id=${data.lastCallData}`);
                // window.location.replace(`http://192.168.1.9/ecom/webb/api/user/user.php?customer_id=${data.lastCallData}`);
                // console.log("Transaction saved:", data);
                // alert("Transaction saved to the database!");
            }
        } catch (error) {
            console.error("Error saving transaction:", error);
        }
    };



    return (
        <div class="w-100 login-bg">
            <div class="login-bg-1">
                <Link to="/app/home" class="logo-wrap"><img src={logoBig} alt="Prometa" class="logo"/></Link>
                <h2 class="tagline mt-2 mt-md-0">Join the Entrepreneurial Revolution</h2>
                {
                    registerData.wallet_address ?
                        <>
                            {
                                isLoading &&
                                <div className='loading-cover'>
                                    <p>Please Wait...</p>
                                </div>
                                // :
                            }
                            <SignupForm registerData={registerData} setRegisterData={setRegisterData} depositUSDT={depositUSDT} />
                        </>
                        :
                        <>
                            <div className="select-network-contiainer">
                                <button className="w-75 sign-in-btn g-recaptcha" onClick={(e) => connectWallet(e)}>Select Network</button>
                            </div>
                        </>
                }
            </div>
        </div>
    )
}

export default Signup;